import {
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
} from "react-icons/fa";

export default function Footer() {
  const addressLink =
    "https://www.google.com/maps/search/?api=1&query=Plot+No.+309,+Flat+No.+202,+2nd+Floor,+Road+No.+6,+Vivekananda+Nagar+Colony,+Kukatpally,+Hyderabad+500072";

  const phoneNumber = "9182643439";
  const email = "contactus@elitecarephysiorehab.com";

  return (
    <footer
      className="footer"
      style={{
        backgroundColor: "#0b1120",
        color: "#94a3b8",
        padding: "60px 80px 20px",
      }}
    >
      <style>
        {`
          .footer-grid {
            display: grid;
            grid-template-columns: 1.5fr 1fr 1fr 1.5fr;
            gap: 40px;
            margin-bottom: 40px;
          }

          .footer-bottom {
            display: flex;
            justify-content: space-between;
            font-size: 14px;
            gap: 20px;
            flex-wrap: wrap;
          }

          .footer-bottom-right {
            display: flex;
            gap: 20px;
            flex-wrap: wrap;
          }

          .footer-link {
            color: #94a3b8;
            text-decoration: none;
            transition: all 0.3s ease;
          }

          .footer-link:hover {
            color: #ffffff;
          }

          .contact-link {
            display: flex;
            align-items: flex-start;
            gap: 10px;
            color: #94a3b8;
            text-decoration: none;
            transition: all 0.3s ease;
            line-height: 1.7;
          }

          .contact-link:hover {
            color: #ffffff;
          }

          .contact-link.phone,
          .contact-link.email {
            align-items: center;
          }

          .social-icons svg {
            cursor: pointer;
            transition: transform 0.3s ease, color 0.3s ease;
          }

          .social-icons svg:hover {
            transform: translateY(-3px);
            color: white;
          }

          @media (max-width: 1024px) {
            .footer {
              padding: 50px 40px 20px !important;
            }

            .footer-grid {
              grid-template-columns: 1fr 1fr;
              gap: 30px;
            }
          }

          @media (max-width: 768px) {
            .footer {
              padding: 40px 20px 20px !important;
            }

            .footer-grid {
              grid-template-columns: 1fr;
              gap: 30px;
            }

            .footer-bottom {
              flex-direction: column;
              align-items: flex-start;
            }

            .footer-bottom-right {
              gap: 16px;
            }
          }

          @media (max-width: 480px) {
            .footer {
              padding: 35px 16px 18px !important;
            }

            .footer-brand h2 {
              font-size: 22px !important;
            }

            .footer-brand p {
              max-width: 100% !important;
              font-size: 14px;
            }

            .footer-grid h4 {
              font-size: 17px !important;
              margin-bottom: 18px !important;
            }

            .footer-grid ul {
              line-height: 2.2 !important;
            }

            .social-icons {
              gap: 16px !important;
              font-size: 18px !important;
            }

            .footer-bottom {
              font-size: 13px !important;
            }
          }
        `}
      </style>

      <div className="footer-grid">
        {/* Brand Section */}
        <div className="footer-brand">
          <h2
            style={{
              fontSize: "24px",
              fontWeight: "bold",
              marginBottom: "20px",
            }}
          >
            <span style={{ color: "#00aeef" }}>ELITE</span>{" "}
            <span style={{ color: "#7cfc00" }}>CARE</span>
          </h2>

          <p
            style={{
              lineHeight: "1.6",
              marginBottom: "20px",
              maxWidth: "300px",
            }}
          >
            Providing top-tier physiotherapy services to help you move better,
            feel better, and live better.
          </p>

          <div
            className="social-icons"
            style={{ display: "flex", gap: "20px", fontSize: "20px" }}
          >
            {/* <GiMedal />
            <FaYoutube />
            <FaAt /> */}
          </div>
        </div>

        {/* Services Section */}
        <div>
          <h4 style={{ color: "white", marginBottom: "25px", fontSize: "18px" }}>
            Services
          </h4>
          <ul style={{ listStyle: "none", padding: 0, lineHeight: "2.5" }}>
            <li>Musculoskeletal</li>
            <li>Sports Injury</li>
            <li>Neuro Rehab</li>
            <li>Pediatric Physio</li>
          </ul>
        </div>

        {/* Company Section */}
        <div>
          <h4 style={{ color: "white", marginBottom: "25px", fontSize: "18px" }}>
            Company
          </h4>
          <ul style={{ listStyle: "none", padding: 0, lineHeight: "2.5" }}>
            <li>About Us</li>
            <li>Our Team</li>
            <li>Careers</li>
            <li>Privacy Policy</li>
          </ul>
        </div>

        {/* Contact Section */}
        <div>
          <h4 style={{ color: "white", marginBottom: "25px", fontSize: "18px" }}>
            Contact
          </h4>

          <div style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
            <a
              href={addressLink}
              target="_blank"
              rel="noopener noreferrer"
              className="contact-link"
            >
              <FaMapMarkerAlt style={{ color: "#7cfc00", marginTop: "5px", minWidth: "16px" }} />
              <span>
                Plot No. 309, Flat No. 202, 2nd Floor,
                <br />
                Road No. 6, Vivekananda Nagar Colony,
                <br />
                Kukatpally, Hyderabad – 500072
              </span>
            </a>

            <a href={`tel:${phoneNumber}`} className="contact-link phone">
              <FaPhoneAlt style={{ color: "#7cfc00" }} />
              <span>{phoneNumber}</span>
            </a>

            <a href={`mailto:${email}`} className="contact-link email">
              <FaEnvelope style={{ color: "#7cfc00" }} />
              <span>{email}</span>
            </a>
          </div>
        </div>
      </div>

      <hr
        style={{
          border: "0",
          borderTop: "1px solid #1e293b",
          marginBottom: "20px",
        }}
      />

      <div className="footer-bottom">
        <p>© 2023 Elite Care Physiotherapy. All rights reserved.</p>
        <div className="footer-bottom-right">
          <span>Terms</span>
          <span>Privacy</span>
          <span>Cookies</span>
        </div>
      </div>
    </footer>
  );
}